import React from "react";
import getClassNameFactory from "../../utilities/classNames";

var Eyebrow = function Eyebrow(_ref) {
  var text = _ref.text;
  var getClassName = getClassNameFactory(Eyebrow.displayName);
  return /*#__PURE__*/React.createElement("p", {
    className: "".concat(getClassName(), " u-typographySmallCaps")
  }, text);
};

Eyebrow.displayName = "Eyebrow";
export default Eyebrow;